import tool from 'common/src/modules/shared/copilot/utils/creators/tool';
import toolResult from 'common/src/modules/shared/copilot/utils/creators/toolResult';
import toolError from 'common/src/modules/shared/copilot/utils/toolError';
import {z} from 'zod';
import {ToolExecuteParams} from 'common/src/modules/shared/copilot/copilot.types';
import {V2CardAgentToolName} from '../../promptToCardAgentV2.enums';
import {OptimizationCardScratchpadState} from '../../scratchpad/optimizationCardScratchpad.types';
import {CLStore} from 'common/src/redux/store';
import getAvailableOptimizeByOptions from '../../utils/optimization/getAvailableOptimizeByOptions';

export default function getOptimizeByOptionsTool(store: CLStore) {
  async function execute(
    _params: ToolExecuteParams<z.ZodObject<Record<string, never>>, OptimizationCardScratchpadState>,
  ) {
    const state = store.getState();
    const campaign = state.campaignPage.campaignTree.campaign;

    if (!campaign) {
      return toolError('Campaign not found in state');
    }

    const availableOptions = getAvailableOptimizeByOptions(campaign.type);

    return toolResult(JSON.stringify(availableOptions));
  }

  return tool<z.ZodObject<Record<string, never>>, OptimizationCardScratchpadState>({
    name: V2CardAgentToolName.GetOptimizeByOptions,
    displayName: 'Getting optimize by options',
    description: 'Get available optimization metrics for this campaign.',
    inputSchema: z.object({}),
    execute,
  });
}
